module.exports = __webpack_public_path__ + "static/media/cert_97.44945339.jpg";